import { isLocal, isQA } from '../constants/apiEnvironments';
export const Integrator = {
  AgentAi: 'AGENT_AI'
};
// `localhost` is allowed in QA (local dev and deployed QA) so partners can test
// the embedder from a local harness against the QA-deployed modal. Never in prod.
const agentAiHostnameRegex = isLocal || isQA ? /^([a-z0-9-]+\.)?agent\.ai$|^localhost$/ : /^([a-z0-9-]+\.)?agent\.ai$/;
export const INTEGRATORS = {
  [Integrator.AgentAi]: {
    hostnameRegex: agentAiHostnameRegex,
    legalLinks: {
      privacyPolicyUrl: 'https://agent.ai/privacy-policy',
      customerTermsUrl: 'https://agent.ai/terms'
    }
  }
};
export const INTEGRATOR_HOSTNAME_REGEXES = Object.keys(INTEGRATORS).map(id => INTEGRATORS[id].hostnameRegex);
export const getIntegratorFromOrigin = origin => {
  try {
    var _find;
    const {
      hostname
    } = new URL(origin);
    return (_find = Object.keys(INTEGRATORS).find(id => INTEGRATORS[id].hostnameRegex.test(hostname))) !== null && _find !== void 0 ? _find : null;
  } catch (_unused) {
    return null;
  }
};
export const getIntegratorLegalLinks = integrator => INTEGRATORS[integrator].legalLinks;